module.exports = __webpack_public_path__ + "img/about-fair-003.63d727a9.jpg";